import { ButtonTriggerEvent } from '../../../../common/components';

export class AccountUsersModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class AccountUsersModalData {
    constructor(public hubName: string) {
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/account.users/account.users.modal.provider.ts